export default __webpack_public_path__ + "images/0x85d84c774cf8e9ff85342684b0e795df72a24908.png";